import { IntegrationsServiceClient } from '@pushwoosh/rpc-service-client/pushwoosh/integrations/IntegrationsServiceClientPb';
import {
  Integration,
  GetPropertiesNamesRequest,
  GetPropertiesNamesResponse,
  GetPropertiesRequest,
  GetPropertiesResponse,
  CreatePropertiesRequest,
  CreatePropertiesResponse,
  ImportSegmentPianoRequest,
  ImportSegmentPianoResponse,
  ListIntegrationsConfigurationRequest,
  ListIntegrationsConfigurationResponse,
} from '@pushwoosh/rpc-service-client/pushwoosh/integrations/integrations_pb';

export type IntegrationsExportClasses = {
  IntegrationsServiceClient: typeof IntegrationsServiceClient;
  Integration: typeof Integration;
  GetPropertiesNamesRequest: typeof GetPropertiesNamesRequest;
  GetPropertiesNamesResponse: typeof GetPropertiesNamesResponse;
  GetPropertiesRequest: typeof GetPropertiesRequest;
  GetPropertiesResponse: typeof GetPropertiesResponse;
  CreatePropertiesRequest: typeof CreatePropertiesRequest;
  CreatePropertiesResponse: typeof CreatePropertiesResponse;
  ImportSegmentPianoRequest: typeof ImportSegmentPianoRequest;
  ImportSegmentPianoResponse: typeof ImportSegmentPianoResponse;
  ListIntegrationsConfigurationRequest: typeof ListIntegrationsConfigurationRequest;
  ListIntegrationsConfigurationResponse: typeof ListIntegrationsConfigurationResponse;
};

export const integrations: IntegrationsExportClasses = {
  IntegrationsServiceClient,
  Integration,
  GetPropertiesNamesRequest,
  GetPropertiesNamesResponse,
  GetPropertiesRequest,
  GetPropertiesResponse,
  CreatePropertiesRequest,
  CreatePropertiesResponse,
  ImportSegmentPianoRequest,
  ImportSegmentPianoResponse,
  ListIntegrationsConfigurationRequest,
  ListIntegrationsConfigurationResponse,
};
